const accordionTimer = () => {
    const INTERVAL = 3500;

    const accordions    = document.querySelectorAll('[data-accordion="accordion-timer"]');
    let activeAccordion = null;
    let activeIdx       = 0;
    let timerAlive      = true;
    let loopTimer       = null;

    const openAt = (idx, runLoader = false) => {
        accordions.forEach((el, i) => {
            const control = el.querySelector('[data-accordion="control"]');
            const content = el.querySelector('[data-accordion="content"]');
            const bar     = el.querySelector('[data-accordion="loader-bar"]');
            const textEl  = el.querySelector('.accordion__text');

            if (i === idx) {
                el.classList.add('open');
                if (control) control.setAttribute('aria-expanded', 'true');
                if (content) content.setAttribute('aria-hidden', 'false');
                activeAccordion = el;

                if (textEl) {
                    setTimeout(() => {
                        textEl.classList.add('active');
                    }, 400);
                }

                if (runLoader && timerAlive && bar) {
                    bar.style.transition = 'none';
                    bar.style.width      = '0%';
                    void bar.offsetWidth;
                    bar.style.transition = `width ${INTERVAL}ms linear`;
                    bar.style.width      = '100%';
                }
            } else {
                el.classList.remove('open');
                if (control) control.setAttribute('aria-expanded', 'false');
                if (content) content.setAttribute('aria-hidden', 'true');

                if (textEl) {
                    textEl.classList.remove('active');
                }

                if (bar) {
                    bar.style.transition = 'none';
                    bar.style.width      = '0%';
                }
            }
        });

        activeIdx = idx;
    };

    const killTimer = () => {
        if (!timerAlive) return;
        timerAlive = false;
        if (loopTimer) clearInterval(loopTimer);

        accordions.forEach((el) => {
            const bar = el.querySelector('[data-accordion="loader-bar"]');
            if (bar) {
                bar.style.transition = 'none';
                bar.style.width      = '0%';
            }
        });
    };

    accordions.forEach((el, index) => {
        const control = el.querySelector('[data-accordion="control"]');
        if (control) {
            control.addEventListener('click', (e) => {
                e.stopPropagation();
                if (el === activeAccordion) return;
                killTimer();
                openAt(index, false);
            });
        }

        const content = el.querySelector('[data-accordion="content"]');
        if (content) {
            content.addEventListener('click', (e) => e.stopPropagation());
        }
    });

    if (accordions.length > 0) {
        openAt(0, true);

        loopTimer = setInterval(() => {
            if (timerAlive) {
                const next = (activeIdx + 1) % accordions.length;
                openAt(next, true);
            }
        }, INTERVAL);
    }
};

export default accordionTimer;
